import { recipes } from './recipes'
import { characterClasses } from './classes'
import { sebina, thirdEvolution } from './evolutions'
import { nameKey } from '../../utils/worldFormat'
import type { Material } from '../../types/progression'

/*
 * Traducciones SOLO para el buscador. En toda la guía los ítems se muestran con su
 * nombre original del juego (inglés). Si un jugador escribe en español, estas
 * equivalencias lo llevan al ítem correcto. Ampliable: agrega "Nombre en el juego": ['alias', …].
 */
const dictionary: Record<string, string[]> = {
  // Joyas
  'Jewel of Chaos': ['joya del caos', 'joya de chaos', 'joc'],
  'Jewel of Bless': ['joya de bendicion', 'joya de la bendicion', 'job'],
  'Jewel of Soul': ['joya del alma', 'jos'],
  'Jewel of Life': ['joya de la vida', 'jol'],
  'Jewel of Creation': ['joya de la creacion', 'joya de creacion'],
  'Jewel of Harmony': ['joya de la armonia', 'joh'],
  'Jewel of Guardian': ['joya del guardian'],
  Gemstone: ['gema', 'piedra preciosa'],
  // Misiones (nombres del catálogo revisado + nombres clásicos como alias)
  'Broken Sword': ['espada rota', 'hachita'],
  'Soul Shard of Wizard': ['alma del mago', 'alma de mago', 'soul of wizard', 'fragmento de alma'],
  'Tear of Elf': ['lagrima de elfa', 'lagrima de elfo'],
  'Abyssal Eye': ['ojo abisal', 'ojo del abismo'],
  'Scroll of the Emperor': ['pergamino del emperador', 'librito', 'libro del emperador', 'scroll of emperor'],
  'Death-beam Knight Flame': ['llama del death beam knight', 'flame of death beam knight'],
  'Hell-Miner Horn': ['cuerno de hell maine', 'cuerno de hell miner', 'horn of hell maine'],
  'Dark Phoenix Feather': ['pluma del fenix', 'pluma del fenix oscuro', 'feather of phoenix of darkness'],
  'Ring of Honor': ['anillo de honor', 'anillo de la gloria'],
  'Ring of Glory': ['anillo de la gloria', 'anillo de honor'],
  'Dark Stone': ['piedra oscura', 'piedra negra'],
  // Materiales de alas y capas
  "Loch's Feather": ['pluma de loch'],
  'Condor Feather': ['pluma de condor', 'pluma del condor'],
  'Feather of Condor': ['pluma de condor', 'pluma del condor'],
  'Condor Flame': ['llama de condor', 'llama del condor'],
  'Flame of Condor': ['llama de condor', 'llama del condor'],
  'Crest of Monarch': ['emblema del monarca', 'escudo del monarca', 'cresta del monarca'],
  // Alas y capas
  'Wings of Satan': ['alas de satan', 'alas del diablo'],
  'Wings of Heaven': ['alas del cielo', 'alas celestiales'],
  'Wings of Elf': ['alas de elfo', 'alas de elfa'],
  'Wings of Curse': ['alas de la maldicion', 'alas malditas'],
  'Wings of Dragon': ['alas de dragon'],
  'Wings of Soul': ['alas del alma'],
  'Wings of Spirits': ['alas de los espiritus', 'alas de espiritu'],
  'Wings of Despair': ['alas de la desesperacion'],
  'Wings of Darkness': ['alas de la oscuridad', 'alas oscuras'],
  'Wings of Storm': ['alas de tormenta', 'alas de la tormenta'],
  'Wings of Eternal': ['alas eternas'],
  'Wings of Illusion': ['alas de ilusion'],
  'Wings of Dimension': ['alas de dimension'],
  'Wings of Ruin': ['alas de la ruina'],
  'Cape of Lord': ['capa del lord', 'capa de lord', 'capa del dark lord'],
  'Cape of Fighter': ['capa del luchador', 'capa del rage fighter'],
  'Cape of Emperor': ['capa del emperador'],
  'Lord of the Cape': ['capa de dominio', 'capa fist master', 'capa rf 3'],
  'Cloak of Warrior': ['capa del guerrero', 'capa rage fighter', 'capa rf'],
  // Equipo (ejemplos; el resto se resuelve con los sinónimos casco/helm, armadura/armor…)
  'Dragon Helm': ['casco dragon', 'casco de dragon', 'casco del dragon'],
  'Dragon Armor': ['armadura dragon', 'armadura de dragon'],
  // Mascotas, cajas y consumibles
  'Horn of Uniria': ['cuerno de uniria'],
  'Horn of Dinorant': ['cuerno de dinorant'],
  'Horn of Fenrir': ['cuerno de fenrir'],
  'Dark Horse': ['caballo oscuro'],
  'Dark Raven': ['cuervo oscuro'],
  'Guardian Angel': ['angel guardian'],
  Imp: ['diablillo'],
  'Box of Kundun': ['caja de kundun'],
  'Box of Kundun 1': ['kundun +1', 'caja kundun +1', 'caja de kundun +1', 'kundun 1'],
  'Box of Kundun 2': ['kundun +2', 'caja kundun +2', 'caja de kundun +2', 'kundun 2'],
  'Box of Kundun 3': ['kundun +3', 'caja kundun +3', 'caja de kundun +3', 'kundun 3'],
  'Box of Kundun 4': ['kundun +4', 'caja kundun +4', 'caja de kundun +4', 'kundun 4'],
  'Box of Kundun 5': ['kundun +5', 'caja kundun +5', 'caja de kundun +5', 'kundun 5'],
  'Box of Luck': ['caja de la suerte', 'caja de suerte'],
  'Healing Potion': ['pocion de vida', 'pocion de curacion', 'pocion roja'],
  'Mana Potion': ['pocion de mana', 'pocion azul'],
  'Town Portal': ['portal a la ciudad', 'pergamino de teletransporte'],
  "Devil's Eye": ['ojo del diablo'],
  "Devil's Key": ['llave del diablo'],
  'Scroll of Archangel': ['pergamino del arcangel'],
  'Blood Bone': ['hueso de sangre'],
  'Invisibility Cloak': ['capa de invisibilidad'],
  "Wizard's Ring": ['anillo del mago'],
  // Monstruos y NPC: expresiones completas (nunca palabras sueltas como "red" o "evil")
  'Red Dragon': ['dragon rojo'],
  'White Wizard': ['mago blanco'],
  'Death King': ['rey de la muerte'],
  'Golden Dragon': ['dragon dorado'],
  'Sebina the Priest': ['sebina', 'sacerdotisa sebina', 'la sacerdotisa'],
  'Apostle Devin': ['devin', 'apostol devin'],
  'Werewolf Quarel': ['quarel'],
  'Chaos Goblin': ['maquina chaos', 'maquina del chaos', 'goblin del chaos', 'chaos machine'],
  // Poderes (se aplican al ítem que enseña la habilidad)
  'Evil Spirit': ['espiritu maligno'],
  'Twisting Slash': ['corte giratorio'],
  'Death Stab': ['estocada mortal'],
}

const INDEX = new Map<string, string[]>()
const add = (english: string | undefined, aliases: (string | undefined)[]) => {
  if (!english) return
  const k = nameKey(english)
  const list = INDEX.get(k) ?? []
  aliases.forEach((a) => a && !list.includes(a) && list.push(a))
  INDEX.set(k, list)
}

Object.entries(dictionary).forEach(([en, es]) => add(en, es))
// Los nombres en español de las guías de progresión también sirven para buscar.
const fromMaterial = (m: Material) => {
  add(m.gameName, [m.esName])
  m.altNames?.forEach((n) => add(n, [m.esName]))
}
recipes.forEach((r) => [...r.ingredients, ...(r.variants ?? []).flatMap((v) => v.ingredients)].forEach(fromMaterial))
// Resultados de recetas: el nombre del catálogo recibe como alias los nombres clásicos (p. ej. "Wings of Curse" → Wing of Curse).
recipes.forEach((r) => [...r.results, ...(r.variants ?? []).flatMap((v) => v.results)].forEach((res) => add(res.gameName, res.altNames ?? [])))
;[sebina.scroll, ...thirdEvolution.stage1.materials].forEach(fromMaterial)
characterClasses.forEach((c) => c.sebinaItem && add(c.sebinaItem.gameName, [c.sebinaItem.esName]))

const REVERSE = new Map<string, string>()
Object.entries(dictionary).forEach(([en, es]) => es.forEach((a) => !REVERSE.has(nameKey(a)) && REVERSE.set(nameKey(a), en)))

/** Nombre original para una expresión completa en español (p. ej. "espada rota" → "Broken Sword"). */
export function englishFor(expression: string): string | undefined {
  return REVERSE.get(nameKey(expression))
}

/** Alias en español de un ítem (por su nombre original). Solo para el buscador. */
export function spanishAliasesFor(englishName: string): string[] {
  return INDEX.get(nameKey(englishName)) ?? []
}
